import React, {Component} from 'react';
import Select from 'react-select';

class Picker extends Component {

    static getDerivedStateFromProps(nextProps, prevState) {
        
        var lookupOptions = loadLookupOptions(nextProps.itemsSource, nextProps.displayMember, nextProps.valueMember);
            var selectedOption = null;

        if (lookupOptions) 
            selectedOption = lookupOptions.find(o => o.id === nextProps.selectedValue);

        var newState = {lookupOptions: lookupOptions, selectedOption: selectedOption};
        
        return newState;
    }

    render() {

        return (
            <Select 
                placeholder={this.props.placeholder}
                options={this.state.lookupOptions}
                value={this.state.selectedOption}
                onChange={this.props.onChange}
                />
        )
    }
}

function loadLookupOptions(_items, _displayMember, _valueMember) {
    var options = [];

    if (_items && _displayMember && _valueMember)
    {
        for (var ix in _items) {
            options.push({id: _items[ix][_valueMember], value: _items[ix][_valueMember], label: _items[ix][_displayMember]});
        }
    }

    return options;
}


export default Picker;